// extracted by mini-css-extract-plugin
module.exports = {"container":"Table_container__2dqnZ","wrapper":"Table_wrapper__23wn4","firstimage":"Table_firstimage__3l3aM","bottomimage":"Table_bottomimage__18Kg8"};